export default __webpack_public_path__ + "static/media/cbas.3edb9439.png";